import React from "react";
import "./styles/CaesarСipherApp.css";
import { BoardProps } from "./Components/types/types";
import Board from "./Components/Board";
import TopBar from "./Components/TopBar";
import Helppanel from "./Components/Helppanel";
import { GameProvider } from "./GameContext";
import { TimerProvider } from "./TimerContext";
import FullscreenToggle from "./Components/hooks/FullscreenToggle";

const AppContent: React.FC<BoardProps> = ({ random, rounds, type }) => {
  return (
    <div id="CaesarСipher-content">
      <div className="CaesarСipher-conteiner">
        <div className="CaesarСipher-titleGame">
          <div
            className={`CaesarСipher-mainsubtitle ${
              type === "1" ? "" : "CaesarСipher--type2"
            }`}
          >
            {type === "1" ? "Шифр Цезаря" : "Подстановочный шифр"}
          </div>
          <FullscreenToggle />
        </div>

        <div className="CaesarСipher-Scene">
          <TopBar />
          <Board random={random} rounds={rounds} type={type} />
        </div>

        <Helppanel />
      </div>
    </div>
  );
};

const App: React.FC<BoardProps> = (props) => {
  return (
    <GameProvider>
      <TimerProvider>
        <AppContent
          random={props.random}
          rounds={props.rounds}
          type={props.type}
        />
      </TimerProvider>
    </GameProvider>
  );
};

export default App;
